import { ReactElement } from 'react';
import { TalkToUsMessage } from '../TalkToUsMessage/TalkToUsMessage';
import * as S from './TalkToUsUnavailable.styles';
import { WORKING_HOURS } from '@/common/app/constants/timeConstants';

const TalkToUsUnavailable = ({ isChat }: { isChat?: boolean }): ReactElement => {
    return (
        <TalkToUsMessage icon="unavailable">
            <li>We are currently closed.</li>
            Please {isChat ? 'chat with' : 'call'} us during normal business hours or book{' '}
            <S.Online>online 24/7</S.Online>
            <br />
            <br />
            <li>{`We are open ${WORKING_HOURS} Monday-Saturday. Hours are subject to change`}</li>
        </TalkToUsMessage>
    );
};

export { TalkToUsUnavailable };
